import React, { useEffect } from 'react';
import {
  useParams,
} from 'react-router-dom';

import useHttpStatus from '~/commons/hooks/useHttpStatus';
import Header from '../../layout/Header.jsx';
import PageHttp from '~/commons/components/PageHttp.jsx';
import FormLevel from '../../forms/FormLevel.jsx';

const PageLevel = () => {
  const { _id } = useParams();
  const [res, req] = useHttpStatus();

  useEffect(() => {
    req({
      url: `/api/quiz/levels/${_id}`,
    });
  }, [_id]);

  const breadcrumb = [
    { to: '../', children: 'Levels' },
  ];

  return (
    <>
      {_id === 'new' ? (
        <div>
          <Header breadcrumb={breadcrumb}>Create New</Header>
          <FormLevel />
        </div>
      ) : (
        <PageHttp res={res}>
          {(doc) => (
            <>
              <Header breadcrumb={breadcrumb}>Editor</Header>
              <FormLevel level={doc} />
            </>
          )}
        </PageHttp>
      )}
    </>
  );
};

export default PageLevel;
